import React from 'react';
import { View, Text } from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
} from 'react-native-reanimated';
import { useThemeColors } from '@/lib/useThemeColors';
import AnimatedPressable from '@/components/AnimatedPressable';

export type TimeRange = '7d' | '30d' | '90d';

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
}

const OPTIONS: { value: TimeRange; label: string }[] = [
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
];

export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  const colors = useThemeColors();

  return (
    <View
      className="flex-row rounded-xl p-1"
      style={{ backgroundColor: colors.surface.secondary }}
    >
      {OPTIONS.map((opt) => {
        const isActive = opt.value === value;
        return (
          <AnimatedPressable
            key={opt.value}
            onPress={() => onChange(opt.value)}
            className="flex-1 items-center justify-center rounded-lg py-2"
            style={{
              backgroundColor: isActive ? colors.surface.primary : 'transparent',
            }}
          >
            <Text
              className="text-xs font-semibold"
              style={{
                color: isActive ? colors.primary[600] : colors.text.tertiary,
              }}
            >
              {opt.label}
            </Text>
          </AnimatedPressable>
        );
      })}
    </View>
  );
}

// Simpler segmented toggle for Startup/Investor tabs
interface SegmentedToggleProps {
  options: string[];
  value: string;
  onChange: (val: string) => void;
}

export function SegmentedToggle({ options, value, onChange }: SegmentedToggleProps) {
  const colors = useThemeColors();

  return (
    <View
      className="flex-row rounded-xl p-1"
      style={{ backgroundColor: colors.surface.secondary }}
    >
      {options.map((opt) => {
        const isActive = opt === value;
        return (
          <AnimatedPressable
            key={opt}
            onPress={() => onChange(opt)}
            className="flex-1 items-center justify-center rounded-lg py-2 px-3"
            style={{
              backgroundColor: isActive ? colors.surface.primary : 'transparent',
            }}
          >
            <Text
              className="text-xs font-semibold"
              style={{
                color: isActive ? colors.primary[600] : colors.text.tertiary,
              }}
            >
              {opt}
            </Text>
          </AnimatedPressable>
        );
      })}
    </View>
  );
}
